import { DWEditor } from 'src/components/editor';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWEditor.displayName, DWEditor);

export default DWEditor;
export { DWEditor };
